/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Form, FormGroup, Alert, Modal, Button } from 'rsuite';
import FilterQueryParams from '../FilterQueryParams';
import { cuotitasStoreService } from '../../services';
import { Field } from '../../helpers/rsuite';

const size = {
    lg: 'lg', // large
    md: 'md', // medium
    sm: 'sm', // small
    xs: 'xs' // extra small
};

const defaultAccountForm = {
    username: '',
    password: '',
};

export default function ViewAccountSettingDialog ({ show, onHide, id }) {
    const formRef = React.useRef();

    // eslint-disable-next-line no-unused-vars
    const [accountForm, setAccountForm] = useState(defaultAccountForm);
    const [defaultAccount, setDefaultAccount] = useState('');

    const [isLoading, setIsLoading] = useState(false);

    const getAccount = (idUser) => {
        setIsLoading(true);
        const options = {};
        const filters = new FilterQueryParams();
        filters.equal('id_user', idUser);
        options.filters = filters.build();
        cuotitasStoreService
            .getUserAccount(options)
            .then(res => {
                const user = res[0]?.loan_user;
                const password = res[0]?.loan_pass;
                setAccountForm({ username: user || '', password: password || '' });
                setDefaultAccount({ username: user || '', password: password || '' });
            })
            .catch(e => {
                console.error(e);
                Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
            })
            .finally(() => setIsLoading(false));
    };

    const handleSubmit = () => {
        const areEqual = accountForm.username === defaultAccount.username && accountForm.password === defaultAccount.password;
        if (areEqual) {
            Alert.warning('No se registraron cambios en la cuenta.', 5000);
            return;
        }
        const data = {
            username: accountForm.username,
            pass: accountForm.password,
            idUser: id
        };
        cuotitasStoreService.createAndUpdateAccount(data)
            .then(res => {
                Alert.success('La información se guardo correctamente', 3000);
                setIsLoading(false);
                return true;
            })
            .catch(e => {
                setIsLoading(false);
                Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
            })
            .finally(() => onHide());
    };

    useEffect(() => {
        getAccount(id);
    }, []);

    return (
        <Modal
            show={show && !isLoading}
            onHide={onHide}
            className={`${show ? 'show in' : ''}`}
            aria-labelledby='user-create-modal'
            size={size.sm}
            keyboard={false}
        >
            <Modal.Header closeButton >
                <Modal.Title id='user-create-modal '>
                    <div className='d-flex justify-content-around'>
                        <span>Set User # {id}</span>
                    </div>
                </Modal.Title>
            </Modal.Header >
            <Modal.Body className='h-75' style={{ overFlow: 'hidden! important' }}>
                {!isLoading && (
                    <div className='row justify-content-center'>
                        <div className='col-md-10'>
                            <Form
                                fluid
                                ref={formRef}
                                formValue={accountForm}
                                onChange={setAccountForm}
                            >
                                <h3>Usuario de LOAN</h3>
                                <div className="container">
                                    <Field classNameGroup='mb-3' classNameLabel='font-weight-bold' label="Usuario" name="username" />
                                    <Field classNameGroup='mb-3' classNameLabel='font-weight-bold' label="Password" name="password" />
                                </div>
                                <FormGroup />
                            </Form>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className='mt-4'>
                <div className='d-flex justify-content-around'>
                    <div />
                    <div>
                        <Button appearance='primary' disabled={isLoading} onClick={handleSubmit} >Guardar</Button>
                        <Button disabled={isLoading} onClick={onHide} >Cancelar</Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
};
